import { FC, useContext, useEffect } from "react";
import confetti from "canvas-confetti";

import { TeamContext, UserContext } from "../../../context";
import { CelebrationAvatar } from "../../organisms"
import { CelebrationMiniProfile } from "../../molecules";
import { IPlayer } from "../../../interfaces";
import { Phase } from "../../../util/enums";
import { useSound } from "../../../hooks";

import goldenCoinForCelebration from "../../../assets/coins/goldenCoinForCelebration.svg";
import { useTranslation } from "react-i18next";
interface CustomHTMLElement extends HTMLCanvasElement {
    confetti: any;
}

interface IDilemmaOwnerCoinCelebration {
    currentTokenValue?: number;
}

const DilemmaOwnerCoinCelebration: FC<IDilemmaOwnerCoinCelebration> = (props) => {
    const { currentTokenValue } = props;
    const { t } = useTranslation();
    const { game } = useContext(TeamContext);
    const { userData } = useContext(UserContext);
    const dilemmaOwnerCelebration = game?.phase === Phase.SOLUTION_CHOSEN_REWARD;
    const spinOwnerCelebration = game?.phase === Phase.RENDER_SPIN_WHEEL;
    const isTheUserSpinOwner = userData?.email === game?.gameInfo.currentSpinOwner;
    const isTheUserDilemaOwner = userData?.email === game?.gameInfo.currentPlayerEmail;
    const isFourthRound = game?.gameInfo.challengeScore === 4;
    const currentTokenValueLocal: number = currentTokenValue || 1;
    const {playSound} = useSound();

    let currentOwnerNickname = "";
    let currentOwnerColor = "pink"

    if (dilemmaOwnerCelebration) {
        const dilemmaOwner = game?.players.find((player: IPlayer) => { return player.email === game.gameInfo.currentPlayerEmail });
        currentOwnerNickname = dilemmaOwner?.nickname || "";
        currentOwnerColor = dilemmaOwner?.color || "pink";
    }

    if (spinOwnerCelebration) {
        const spinOwner = game?.players.find((player: IPlayer) => { return player.email === game.gameInfo.currentSpinOwner });

        currentOwnerNickname = spinOwner?.nickname || "";
        currentOwnerColor = spinOwner?.color || "pink";
    }

    useEffect(() => {
        addConfetti();
    }, [])

    useEffect(() => {
        if(dilemmaOwnerCelebration) 
            playSound("/sounds/bell.mp3");
       
    }, [dilemmaOwnerCelebration, playSound])

    useEffect(() => {
        const timeout = setTimeout(() => {
            playSound("/sounds/PositiveAlert3.mp3");
        }, 500);
        return () => clearTimeout(timeout); 
    }, [playSound]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            playSound("/sounds/MusicPositive2.mp3");
        }, 2250);
        return () => clearTimeout(timeout); 
    }, [playSound]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            playSound("/sounds/CoinCollect.mp3");
        }, 2250)
        return () => clearTimeout(timeout);
    }, [playSound]);

    const addConfetti = () => {
        const htmlCanvas = document.getElementById("confeti") as CustomHTMLElement;

        htmlCanvas!.confetti = htmlCanvas!.confetti || confetti.create(htmlCanvas, { resize: true });
        htmlCanvas!.confetti({
            particleCount: 300,
            angle: 90,
            spread: 180,
            gravity: 1,
            zIndex: 1,
            startVelocity: 50,
            scalar: 2,
            colors: ["#53BD8B", "#FF00A7", "#005776", "#FED100"],
            resize: true
        });
    }

    const dilemmaOwnerCelebrationHeaderText = () => {
        return (
            <div className="selected_cards_celebration_title">
                <div className="title_small"> {t("congratulationsText")}, <span className={`text_color_${currentOwnerColor}`}>{currentOwnerNickname}</span>{t("exclamationText")} </div>
                {isTheUserDilemaOwner && <div className="title_big"> {isFourthRound ? t("youGot6UpperTokensText") : t("youGot3UpperTokensText")} </div>}
                {!isTheUserDilemaOwner && <div className="title_big"> <span className={`text_color_${currentOwnerColor}`}>{currentOwnerNickname}</span> {isFourthRound ? t("userName_got6UpperTokensText") : t("userName_got3UpperTokensText")} </div>}
            </div>
        )
    }

    const spinOwnerCelebrationHeaderText = () => {
        if (isTheUserSpinOwner) {
            return (
                <div className="selected_cards_celebration_title">
                    <div className="title_small"> {t("congratulationsText")}{t("commaText")} <span className={`text_color_${currentOwnerColor}`}>{currentOwnerNickname}</span>{t("exclamationText")} </div>
                    <div className="title_big"> {t("youGot_number_tokensText")} {isFourthRound ? currentTokenValueLocal*2 : currentTokenValueLocal} {t("upperTokenText")} {currentTokenValueLocal > 1 ? <span> {t("tokenText")}{t("exclamationText")}</span> : <span> {t("tokensText")}{t("exclamationText")}</span>} </div>
                </div>
            )
        }

        return (
            <div className="selected_cards_celebration_title">
                <div className="title_small"> {t("wowText")} </div>
                <div className="title_big"> <span className={`text_color_${currentOwnerColor}`}>{currentOwnerNickname}</span> {t("userName_got_tokensText")} {isFourthRound ? currentTokenValueLocal*2 : currentTokenValueLocal} {t("upperTokensText")} </div>
            </div>
        )
    }

    return (
        <div className="full_screen render_selected_cards_celebration">

            <div className="full_screen coin_position_holder" >
                <div className="full_screen center_horizontally_and_vertically" >
                    <div className="coins_wrapper">

                        <div className="relatible">
                            <div className="base one">
                                <img className="celebration_coin delay_5" src={goldenCoinForCelebration} alt="coin" />
                            </div>
                            <div className="base two">
                                <img className="celebration_coin delay_5" src={goldenCoinForCelebration} alt="coin" />
                            </div>
                            <div className="base three">
                                <img className="celebration_coin delay_5" src={goldenCoinForCelebration} alt="coin" />
                            </div>
                            <div className="base four">
                                <img className="celebration_coin delay_5" src={goldenCoinForCelebration} alt="coin" />
                            </div>
                            <div className="base five">
                                <img className="celebration_coin delay_5" src={goldenCoinForCelebration} alt="coin" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="full_screen position_absolute" >
                <div className="celebration_user_mini_profile"></div>
            </div>

            {dilemmaOwnerCelebration && dilemmaOwnerCelebrationHeaderText()}

            {spinOwnerCelebration && spinOwnerCelebrationHeaderText()}

            <div className="gradient_line_holder center_horizontally_and_vertically">
                <div className="linear_gradient_line_horizontal" style={{ width: "50%" }}></div>
            </div>

            <div className="selected_cards_celebration_body">

            </div>

            <CelebrationAvatar avatarColor={currentOwnerColor} />
            <CelebrationMiniProfile />

            <canvas id="confeti" style={{ position: 'absolute', width: '99%', height: '99%', zIndex: 50, borderRadius: '50%' }} />
        </div>
    )
}

export default DilemmaOwnerCoinCelebration;